/** Remaining time on a live event queue, for Home / Lobby / the mode sheet. */
export function formatEventCountdown(endsAt: string, now = Date.now()): string {
  const end = Date.parse(endsAt)
  if (Number.isNaN(end)) return ''
  let sec = Math.max(0, Math.floor((end - now) / 1000))
  const days = Math.floor(sec / 86400)
  sec %= 86400
  const hours = Math.floor(sec / 3600)
  sec %= 3600
  const minutes = Math.floor(sec / 60)
  const seconds = sec % 60
  const hh = String(hours).padStart(2, '0')
  const mm = String(minutes).padStart(2, '0')
  const ss = String(seconds).padStart(2, '0')
  if (days > 0) return `${days}d ${hh}:${mm}:${ss}`
  if (hours > 0) return `${hours}:${mm}:${ss}`
  return `${minutes}:${ss}`
}
